import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import LoaderSpiner from "../../../../components/loaderSpiner";
import { useLazyGetOrderedBySavesQuery } from "../../../../services/Api";


function OrderedBySaves() {
  const [chartData, setChartData] = useState([]);
  const [total, setTotal] = useState(0);
  const [trigger, { data: Data, isLoading, error }] =
    useLazyGetOrderedBySavesQuery();

  useEffect(() => {
    trigger();
  }, [trigger]);

  useEffect(() => {
    if (Data?.data) {
      const transformedData = Data.data.map((item) => ({
        name: item.title,
        value: item.savedByCount,
      }));
      setChartData(transformedData);

      const totalValue = transformedData.reduce(
        (sum, item) => sum + item.value,
        0
      );
      setTotal(totalValue);
    }
  }, [Data]);

  const [fontSize, setFontSize] = useState(12);
  const [barSize, setBarSize] = useState(60);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setFontSize(width < 768 ? 10 : 12); // Smaller font on mobile
      setBarSize(width < 768 ? 30 : 60); // Smaller bars on mobile
    };

    handleResize(); // Initialize values
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isLoading) return <LoaderSpiner />;
  if (error)
    return (
      <div className="text-errorcolor p-4 text-center">
        Error loading data. Please try again later.
      </div>
    );


  return (
    <div className="w-full">
      {chartData.length === 0 ? (
        <div className="flex items-center justify-center h-[300px]">
          <p className="text-gray-500 text-center">No data available</p>
        </div>
      ) : (
        <div className="w-full mx-auto h-[400px] overflow-hidden">
          <div className="h-full flex flex-col">
            {/* Chart Header */}
            <div className="flex justify-end items-center">
              <span className="text-lg md:text-xl font-semibold text-emerald-600 ">
                Total Saves: {total}
              </span>
            </div>

            {/* Chart and Legend Container */}
            <div className="flex flex-col lg:flex-row gap-2 h-full">
              {/* Chart Container */}
              <div className="flex-1 overflow-hidden w-full">
                <ResponsiveContainer width="100%" height="85%">
                  <BarChart
                    data={chartData}
                    margin={{ top: 20, right: 20, left: -10, bottom: 20 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
                    <XAxis
                      dataKey="name"
                      tick={{ fontSize }}
                      interval={0}
                      angle={-10}
                      height={70}
                      textAnchor="end"
                    />
                    <YAxis tick={{ fontSize }} tickFormatter={(value) => value.toLocaleString()} />
                    <Tooltip
                      contentStyle={{
                        backgroundColor: "#3D5673",
                        color: "#FFF",
                        borderRadius: "8px",
                        padding: "8px",
                        fontSize: `${fontSize}px`,
                        border: "none",
                      }}
                      labelStyle={{
                        fontWeight: "bold",
                        fontSize: `${fontSize}px`,
                        marginBottom: "4px",
                      }}
                      formatter={(value) => [value.toLocaleString(), "Saves"]}
                    />
                    <Bar dataKey="value" fill="#10B981" radius={[6, 6, 0, 0]} maxBarSize={barSize} />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OrderedBySaves;
